type CampaignType =
    | 'NEWSLETTER'
    | 'Newsletter'
    | 'BROADCAST'
    | 'Broadcast'
    | 'DRIP_SEQUENCE'
    | 'DripSequence'
    | 'TEMPLATE'
    | 'Template'
    | 'AI_EMAIL_TEMPLATE'
    | 'AiEmailTemplate'
    | 'AI_STARTER_TEMPLATE'
    | 'AiStarterTemplate';

export function getUserFacingNoun(campaignType: CampaignType) {
    if (campaignType === 'NEWSLETTER' || campaignType === 'Newsletter') {
        return 'edition';
    }

    if (
        campaignType === 'BROADCAST' ||
        campaignType === 'Broadcast' ||
        campaignType === 'AI_EMAIL_TEMPLATE' ||
        campaignType === 'AiEmailTemplate'
    ) {
        return 'broadcast';
    }

    if (campaignType === 'TEMPLATE' || campaignType === 'Template') {
        return 'template';
    }

    // If a drip sequence or as a default/fallback
    return 'message';
}
